module.exports = __webpack_public_path__ + "static/media/project4.f18568c0.jpg";